/**
 * @module events/types/afterPrint
 */

/**
 * @type {string}
 */
export default 'afterprint'